import { NOTE_SUGGESTION_TYPES } from "models";
import { useLocationWithSuggestionsQuery } from "modules/NoteSuggestions/hooks/useLocationWithSuggestionsQuery";

import type { NoteSuggestionTypeWithSuggestions } from "modules/NoteSuggestions/hooks/useNoteSuggestionMutation";

type NoteSuggestionTypeLookup = {
  icon: string;
  translation_key: string;
  default_message: string;
};

export const NoteSuggestionTypeLookupMap = new Map<NOTE_SUGGESTION_TYPES | null, NoteSuggestionTypeLookup>([
  [NOTE_SUGGESTION_TYPES.CallCustomer, { icon: "phone", translation_key: "v8_call_customer_note", default_message: "Customer note" }],
  [NOTE_SUGGESTION_TYPES.RemarkPin, { icon: "thumbtack", translation_key: "v8_remark_pin", default_message: "Remark pin" }],
  [NOTE_SUGGESTION_TYPES.WarrantyPin, { icon: "shield alternate", translation_key: "v8_warranty_pin", default_message: "Warranty pin" }],
  [NOTE_SUGGESTION_TYPES.RecallPin, { icon: "registered", translation_key: "v8_recall_pin", default_message: "Recall pin" }],
  [NOTE_SUGGESTION_TYPES.Parking, { icon: "square parking", translation_key: "v8_parking_note", default_message: "Parking note" }]
]);

export const useNoteTypesWithSuggestionsQuery = () => {
  const { location, isLoading } = useLocationWithSuggestionsQuery();

  const noteTypesWithSuggestions: NoteSuggestionTypeWithSuggestions[] =
    location?.note_suggestion_types?.map(nst => {
      const matchingNoteInfo = NoteSuggestionTypeLookupMap.get(nst.note_suggestion_type_id) ?? { icon: "", translation_key: "", default_message: "" };
      const note_suggestions = location.note_suggestions?.filter(s => s.note_suggestion_type_id === nst.note_suggestion_type_id) ?? [];
      return { note_suggestion_type: { ...nst }, ...matchingNoteInfo, note_suggestions };
    }) ?? [];

  return { noteTypesWithSuggestions, isLoadingNoteSuggestionTypes: isLoading };
};
